import { render } from "./TeamPlayerResetPasswordButton.vue?vue&type=template&id=3b7e7ac2&scoped=true"
import script from "./TeamPlayerResetPasswordButton.vue?vue&type=script&lang=js"
export * from "./TeamPlayerResetPasswordButton.vue?vue&type=script&lang=js"

import "./TeamPlayerResetPasswordButton.vue?vue&type=style&index=0&id=3b7e7ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7e7ac2"]])

export default __exports__